<ul class="disconnect">
  <li class="dropdown">
    <a class="link-logout" href="javascript:void(0)" (click)="onLogout()">
      <fa-icon [icon]="['fa', 'power-off']"></fa-icon>
      &nbsp;
      <span>{{ user.firstname }}&nbsp;{{ user.lastname }}</span>
    </a>
  </li>
</ul>
